const state = {
    companies:{},
    users:[],
}

export default state
